<script>
    import StripeForm from './StripeForm.vue'
    import SepaDebitForm from './SepaDebitForm.vue'
    import {Form} from '../../helpers/Form/Form'

    export default {
        props: ['sportmenprop', 'routeTabs', 'mainForm', 'showButton'],
        components: {StripeForm,SepaDebitForm},
        data() {
            return {
                maxInstalments: 12,
                soisy_results: null,
                pagolightMinorAmount: 111,
                soisy: new Form({
                    id: Math.random(),
                    instalments: 3,
                    amount: null
                }),
              pagolight: new Form({
                id: Math.random(),
                instalments: 3,
                amount: null
              }),
                form: this.mainForm,
                total: 0,
                selected: 'first',
                options: [
                    {text: 'First radio', value: 'first'},
                    {text: 'Second radio', value: 'second'},
                ],
                payment: 'card'
            }
        },
        computed: {
            hasAlreadySaveACard() {
                return !_.isEmpty(this.mainForm.card_brand) && !_.isEmpty(this.mainForm.card_last_four) && !_.isEmpty(this.mainForm.stripe_id)
            }
        },
        watch: {
            payment(value) {
                this.$bus.$emit('reset-form-data')
            },
          'pagolight.instalments': {
            handler(val) {
              if (!_.isNull(val)) {
                this.setBubble();
                this.pagolightSimulation()
              }
            }
          },
          'soisy.instalments': {
                handler(val) {
                    if (!_.isNull(val)) {
                        this.setBubble();
                        this.soisySimulation()
                    }
                }
            },            
        },
        mounted() {
            this.initPagolight()

            this.$bus.$on('submit-payment', () => {
                this.onSubmit()
            })
        },
        methods: {
           initPagolight() {
                this.setBubble();
                this.pagolightSimulation()
            },
            setBubble() {
                if (!this.$refs.range) {
                    return
                }
                let val = this.pagolight.instalments;
                let min = this.$refs.range.min ? this.$refs.range.min : 0;
                let max = this.$refs.range.max ? this.$refs.range.max : 100;
                let newVal = Number(((val - min) * 100) / (max - min));
                this.$refs.bubble.innerHTML = val;
                let newPosition = 10 - (newVal * 0.2)

                // Sorta magic numbers based on size of the native UI thumb
                this.$refs.bubble.style.left = `calc(${newVal}% + (${newPosition}px))`;
            },
          pagolightSimulation() {
            this.pagolightMinorAmount = (this.form.total / this.pagolight.instalments).toFixed(2)
          },
            async soisySimulation() {
                this.$set(this.soisy, 'amount', this.form.total)

                let soisyAmount = this.form.total * 100
                if (soisyAmount >= 10000 && soisyAmount <= 1500000) {
                    await this.soisy
                        .get(route('soisy.loan_quotes'))
                        .then(response => {
                            let min = {}
                            this.$set(this, 'soisy_results', response)
                            if (this.soisy_results.hasOwnProperty('median')) {
                                min = Object.assign(this.soisy_results.median, {
                                    convertedInstalmentAmount: this.soisy_results.median.instalmentAmount / 100
                                })
                            }
                            
                            this.$set(this.soisy_results, 'min', min)
                        })
                        .catch(error => {
                            //
                        })
                }
            },
            onBack() {
                // if (this.hasAlreadySaveACard) {
                //     this.$emit('reset-sub-tab')
                // } else {
                    let idx = _.findIndex(this.routeTabs, r => r == 'payment')
                    this.$emit('update-tab', this.routeTabs[idx - 1])
                // }
            },
            onSubmit() {
                if (!['card', 'sepa_debit', 'soisy'].includes(this.payment)) {
                    let data = {payment: this.payment}
                    
                    this.$emit('update-form-data', {data})
                    this.$emit('update-tab', 'confirm')
                    this.$emit('reset-sub-tab')
                    return
                }

                if (this.payment == 'card') {
                    this.processCreditCard()
                } else if (this.payment == 'sepa_debit') {
                    this.processSepaDebit()
                } else if (this.payment == 'soisy') {
                    this.processSoisy()
                }     
            },
            processSoisy() {
                let data = {
                    instalments: this.soisy.instalments,
                    save_card: false,
                    payment: this.payment
                }       

                this.$emit('update-form-data', {data})
                this.$emit('update-tab', 'confirm')
                this.$emit('reset-sub-tab')                        
            },
            processSepaDebit() {
                this.$refs
                    .paymentSepaDebitStripe
                    .onSubmit()
                    .then(({token, cardElements, stripe}) => {
                        let data = {
                            stripeToken: token.id,
                            save_card: false,
                            payment: this.payment,
                        }       

                        this.$emit('update-stripe', {
                            cardElements,
                            form: stripe
                        })
                        this.$emit('update-form-data', {data})
                        this.$emit('update-tab', 'confirm')
                        this.$emit('reset-sub-tab')                        
                    })
                    .catch(error => {
                        window.alerts.error('Attenzione, ricontrolla i dati del tuo conto.')
                    })
            },
            processCreditCard() {
                this.$refs
                    .paymentStripe
                    .onSubmit()
                    .then(({token, cardElements, stripe, save_card}) => {
                        // console.log(token, stripe, cardElements)
                        let data = {
                            stripeToken: token.id,
                            card_brand: token.card.brand,
                            card_last_four: token.card.last4,
                            save_card,
                            payment: this.payment
                        }

                        this.$emit('update-stripe', {
                            cardElements,
                            form: stripe
                        })
                        this.$emit('update-form-data', {data})
                        this.$emit('update-tab', 'confirm')
                        this.$emit('reset-sub-tab')
                    })
                    .catch(error => {
                        window.alerts.error("Si è verificato un errore, riprova")
                    })                
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/cart/PaymentForm.vue